import parseColor from 'color';
import { getSiteColors } from '../../../../utils';

export const encodeColor = (color) => {
  const rgba = color.name
    ? parseColor(getSiteColors().find((c) => c.name === color.name).value)
        .alpha(color.opacity)
        .rgb()
        .string()
    : parseColor(color.value).alpha(color.opacity).rgb().string();

  return {
    opacity: color.opacity,
    rgba,
    color: color.name
      ? {
          value: rgba,
          ...getSiteColors().find((c) => c.name === color.name),
        }
      : false,
  };
};
